// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"624":"clere","888":"course-setup","990":"venue-manager"}[chunkId] || chunkId) + "." + {"160":"6ddd7ae5","173":"3eaa2e23","368":"046926f6","624":"94e6b339","888":"682f8b8a","990":"5e7d8252"}[chunkId] + ".css";
};